import { GlButton, GlAnimatedChevronLgDownUpIcon, GlCollapse } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import AgentStatusIcon from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/shared/widgets/agent_status_icon.vue?vue3';
import AgentSessionRow from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/shared/widgets/agent_session_row.vue?vue3';
export default {
    name: 'AgentSessionsGroup',
    components: {
        GlButton,
        GlAnimatedChevronLgDownUpIcon,
        GlCollapse,
        AgentStatusIcon,
        AgentSessionRow
    },
    props: {
        group: {
            type: Object,
            required: true
        },
        headerBgClass: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            collapsed: false
        };
    },
    computed: {
        toggleLabel () {
            return this.collapsed ? __('Expand') : __('Collapse');
        }
    }
};
